module.exports = __webpack_public_path__ + "img/smily_face.a38aff2f.svg";